export default "__VITE_ASSET__SQQq7Imq__"